import { CONSTANTS as WEB_STORAGE_CONSTANTS } from '@adapter/web-storage';

export const STORAGE_CONSTANTS = {
  ...WEB_STORAGE_CONSTANTS,
 SERVER_TIME_DATA: 'SERVER_TIME_DATA',
 ACCOUNT_AGG_CALLBACK_ID: 'ACCOUNT_AGG_CALLBACK_ID',
  FNO_ONBOARDING_DATA: 'FNO_ONBOARDING_DATA',
 REFRESH_TOKEN: 'REFRESH_TOKEN',
};

import * as storage from '@groww-tech-pvt/web-storage';
    
export const STORAGE_KEY_CONSTANTS = {
  PREVIOUS_MOBILE: 'sspr43334k',
  REDIRECTION_URL: 'sdifgdsuiycfswe76hjer3',
  FNO_RISK_SCREEN: 'FNO_RISK_SCREEN',
  NOMINEE_OPTED_OUT_DURING_ONB: 'NOMINEE_OPTED_OUT_DURING_ONB',
  NOMINEE_RETURN_TO_EXPLORE: 'NOMINEE_RETURN_TO_EXPLORE',
  NOMINEE_NUDGE_LAST_SHOWN: 'NOMINEE_NUDGE_LAST_SHOWN',
  LAST_REFRESHED_MARKET_CALENDAR_DATA: 'LAST_REFRESHED_MARKET_CALENDAR_DATA',
  STOCKS_WALLET_BALANCE_CACHE: 'ksdjfherioubgskweyeopo',
  USER_DATA_PERSIST_BY_ZUSTAND: 'sdfsdusersdfdatasdfstore',
  FLOATING_WINDOW_POSITION: 'floating_window_position',
UTM_SOURCE_POPUP_SEEN: 'UTM_SOURCE_POPUP_SEEN',
  WEBVIEW_DEVICE_ID: 'habsdhkasbdhjkbaskh',
  UI_THEME: 'bfdskfds'
};

export const STORAGE_TYPE = {
  LOCAL_STORAGE: storage.STORAGE_TYPE_AVAILABLE.LOCAL_STORAGE,
  SESSION_STORAGE: storage.STORAGE_TYPE_AVAILABLE.SESSION_STORAGE,
  COOKIE: storage.STORAGE_TYPE_AVAILABLE.COOKIE,
  LOCAL_COOKIE_STORAGE: storage.STORAGE_TYPE_AVAILABLE.LOCAL_COOKIE_STORAGE,
} as const;

// Redirect to explore after nominee addition if the user starts nominee addition journey post onboarding completion
export const NOMINEE_RETURN_TO_EXPLORE_TTL_MS = 10 * 60 * 1000;